<template>
<div class="kt-widget">
    <slot></slot>
</div>    
</template>

<script>
export default {
    
}
</script>